// passwordOptions contains all necessary string data needed to generate the password
const passwordOptions = {
  num: '1234567890',
  specialChar: '!@#$%*_-^',
  lowerCase: 'abcdefghijklmnopqrstuvwxyz',
  upperCase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
};

// Generate a random integer r with equal chance in  0 <= r < max.
function randRange(max) {
  const requestBytes = Math.ceil(Math.log2(max) / 8);
  if (!requestBytes) {
    // No randomness required
    return 0;
  }
  const maxNum = 256 ** requestBytes;
  const ar = new Uint8Array(requestBytes);

  while (true) {
    window.crypto.getRandomValues(ar);

    let val = 0;
    for (let i = 0; i < requestBytes; i += 1) {
      // eslint-disable-next-line no-bitwise
      val = (val << 8) + ar[i];
    }

    if (val < maxNum - (maxNum % max)) {
      return val % max;
    }
  }
}

function getRandomChar(fromString) {
  return fromString[randRange(fromString.length)];
}

export const generatePassword = () => {
  const passwordMinimumLength = 8;
  const passwordMaximumLength = 40;
  const passwordLength = Math.random() * (passwordMaximumLength - passwordMinimumLength)
    + passwordMinimumLength;

  let passInfo = '';

  // list of chosen characters
  const passChars = [];
  // add a number to the list of chosen characters
  passInfo += passwordOptions.num;
  passChars.push(getRandomChar(passwordOptions.num));

  // add a special character to the list of chosen characters
  passInfo += passwordOptions.specialChar;
  passChars.push(getRandomChar(passwordOptions.specialChar));

  // add a lowercase character to the list of chosen characters
  passInfo += passwordOptions.lowerCase;
  passChars.push(getRandomChar(passwordOptions.lowerCase));

  // add an uppercase character to the list of chosen characters
  passInfo += passwordOptions.upperCase;
  passChars.push(getRandomChar(passwordOptions.upperCase));

  // while there aren't enough characters
  while (passChars.length < passwordLength) {
    // choose a random char from charInfo
    passChars.push(getRandomChar(passInfo));
  }

  for (let i = passChars.length - 1; i > 0; i -= 1) {
    const swapIndex = randRange(i + 1);
    const temp = passChars[i];
    passChars[i] = passChars[swapIndex];
    passChars[swapIndex] = temp;
  }
  return passChars.join('');
};
